import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import { ENABLE_REDUX_DEV_TOOLS } from 'src/constants'
import rootReducer from './rootReducer'

const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types example
        ignoredActions: ['your/action/type'],
        // Ignore these field paths in all actions
        ignoredActionPaths: [
          'payload.cargoFilteringForm.from',
          'payload.cargoFilteringForm.to',
          'payload.parcelsFilteringForm.from',
          'payload.parcelsFilteringForm.to',
        ],
        // Ignore these paths in the state example
        ignoredPaths: ['items.dates'],
      },
    }),
  reducer: rootReducer,
  devTools: ENABLE_REDUX_DEV_TOOLS,
})

export const useSelector = useReduxSelector

export const useDispatch = () => useReduxDispatch()

export default store
